import {
  IconTitleDescriptionActionCard,
  LazyLoadedImage,
} from "@reusejs/react";
import { useSelector } from "react-redux";
import { getWatermarkedImgixUrl } from "services";

const ProfilePhoto = (props: any) => {
  const userProfile = useSelector((state: any) => {
    return state.auth?.user?.profile;
  });

  return (
    <div className="relative rounded-lg overflow-hidden h-12 w-12 shadow-md">
      {userProfile?.profile_picture ? (
        <LazyLoadedImage
          src={getWatermarkedImgixUrl(
            `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${userProfile?.profile_picture}?fit=crop&w=112&h=112&auto=format`,
          )}
          placeholderSrc={getWatermarkedImgixUrl(
            `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e07803a8-7771-4c1d-8128-f2580524bd03?fit=crop&w=112&h=112&auto=format`,
          )} // change this once deepak gives the placeholder image
          width={48}
          height={48}
        />
      ) : (
        <LazyLoadedImage
          src={getWatermarkedImgixUrl(
            `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e07803a8-7771-4c1d-8128-f2580524bd03?fit=crop&w=112&h=112&auto=format`,
          )}
          placeholderSrc={getWatermarkedImgixUrl(
            `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e07803a8-7771-4c1d-8128-f2580524bd03?fit=crop&w=112&h=112&auto=format`,
          )}
          width={48}
          height={48}
        />
      )}
    </div>
  );
};

const ProfileDetailSection = () => {
  const userEmail = useSelector((state: any) => {
    return state.auth.userEmail;
  });
  const userProfile = useSelector((state: any) => {
    return state.auth.user?.profile;
  });

  const genarateName = () => {
    if (userProfile?.bio?.full_name) {
      return userProfile?.bio?.full_name;
    } else if (userProfile?.bio?.first_name && userProfile?.bio?.last_name) {
      return (
        userProfile?.bio?.first_name.charAt(0).toUpperCase() +
        userProfile?.bio?.first_name.slice(1) +
        " " +
        userProfile?.bio?.last_name
      );
    } else if (userProfile?.bio?.first_name) {
      return (
        userProfile?.bio?.first_name.charAt(0).toUpperCase() +
        userProfile?.bio?.first_name.slice(1)
      );
    } else {
      return "";
    }
  };

  let profileData = {
    name: genarateName(),
    email: userEmail,
    phone: userProfile?.bio?.mobile_number
      ? userProfile?.bio?.mobile_number
      : "",
    image: <ProfilePhoto />,
  };

  return (
    <div className="mt-5">
      <IconTitleDescriptionActionCard
        title={profileData.name}
        description={profileData.email}
        icon={profileData.image}
        iconPosition="top-center"
        itemTitleDescriptionCardBaseClasses={{
          wrapper: "p-4",
          titleWrapper: "mt-2 font-bold text-gray-900",
          titleStyles: "text-base text-gray-900",
          descriptionWrapper: "mt-2",
          descriptionStyles: "text-xs text-gray-500",
          actionWrapper: "mt-6",
          iconWrapper:
            "flex h-12 w-12 items-center justify-center rounded-md text-white",
        }}
      />
    </div>
  );
};

export default ProfileDetailSection;
